import { render, staticRenderFns } from "./UserCompetitionsFuture.vue?vue&type=template&id=4c4c67fc&scoped=true&"
import script from "./UserCompetitionsFuture.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionsFuture.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionsFuture.vue?vue&type=style&index=0&id=4c4c67fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4c67fc",
  null
  
)

export default component.exports